// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2WsVG","buttons":"SendReceipts_buttons__1Izzq","email":"SendReceipts_email__1GjQa","bookApptTitle":"SendReceipts_bookApptTitle__1SGQ5"};